import { render, staticRenderFns } from "./AutoGamResolutionTable.vue?vue&type=template&id=e2164be8"
import script from "./AutoGamResolutionTable.vue?vue&type=script&lang=js"
export * from "./AutoGamResolutionTable.vue?vue&type=script&lang=js"
import style0 from "./AutoGamResolutionTable.vue?vue&type=style&index=0&id=e2164be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports